// extracted by css-extract-rspack-plugin
export default {"FullWidthContainer":"FullWidthContainer-module__FullWidthContainer___WzGfV"};